import { render, staticRenderFns } from "./VatPopupManager.vue?vue&type=template&id=07f48361&"
import script from "./VatPopupManager.vue?vue&type=script&lang=js&"
export * from "./VatPopupManager.vue?vue&type=script&lang=js&"
import style0 from "./VatPopupManager.vue?vue&type=style&index=0&id=07f48361&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports